import React, { useMemo } from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks/useRefreshPage';

import PendingStockListItem from './PendingStockListItem';

const PendingStockList = ({
	items,
	refetch,
	customProps,
	onScroll,
	scrollEventThrottle,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	const resolvedCustomProps = useMemo(() => {
		return {
			...(customProps || {}),
			refetchList: refetch,
		};
	}, [customProps, refetch]);

	return (
		<List
			items={items}
			listItemComponent={PendingStockListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No pending stock found"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={resolvedCustomProps}
			onScroll={onScroll}
			scrollEventThrottle={scrollEventThrottle}
			assembler={[]}
		/>
	);
};

export default ListContainer(PendingStockList);
